<template>

    <b-card class="mb-2" :bg-variant=" properVariant ">

        <b-row>

            <b-col class="d-flex justify-content-between align-items-center">

                <div>
                    <p class="small mb-0" v-if=" currentlyThisOne "><b>Found Match</b></p>
                    <p class="small mb-0"><b>UpdID: </b>{{ provider.UpdId }}</p>
                    <p class="small mb-0"><b>Composite Score: </b>{{ provider.CompositeScore }} </p>
                </div>
                <div>

                    <b-button size="sm" v-b-tooltip.hover title="View Full Match Results" variant="info" @click=" modal = true "><i class="fa fa-eye"></i></b-button>
                    <b-button size="sm" v-b-tooltip.hover title="Select Provider" variant="success" @click=" selectThis( provider ) " :disabled=" selectedProvider && !isSelected "><i class="fa fa-check-circle"></i></b-button>
                </div>
            </b-col>
        </b-row>

        <b-modal v-model=" modal " :title=" `Provider UPD ${provider.UpdId}` " size="lg" no-close-on-backdrop>

            <b-container fluid>

                <b-row>

                    <b-col sm="8">

                        <p class="mb-0 small"><b>Salutation: </b>{{ provider.IndependentProvider.Salutation }}</p>
                        <p class="mb-0 small"><b>Suffix: </b>{{ provider.IndependentProvider.Suffix }}</p>
                        <p class="mb-0 small"><b>FirstName: </b>{{ provider.IndependentProvider.FirstName }}</p>
                        <p class="mb-0 small"><b>MiddleName: </b>{{ provider.IndependentProvider.MiddleName }}</p>
                        <p class="mb-0 small"><b>LastName: </b>{{ provider.IndependentProvider.LastName }}</p>
                        <p class="mb-0 small"><b>AddressLine1: </b>{{ provider.IndependentProvider.AddressLine1 }}</p>
                        <p class="mb-0 small"><b>AddressLine2: </b>{{ provider.IndependentProvider.AddressLine2 }}</p>
                        <p class="mb-0 small"><b>City: </b>{{ provider.IndependentProvider.City }}</p>
                        <p class="mb-0 small"><b>State: </b>{{ provider.IndependentProvider.State }}</p>
                        <p class="mb-0 small"><b>Zip: </b>{{ provider.IndependentProvider.Zip }}</p>
                        <p class="mb-0 small"><b>CountryCode: </b>{{ provider.IndependentProvider.CountryCode }}</p>
                        <p class="mb-0 small"><b>Phone: </b>{{ provider.IndependentProvider.Phone }}</p>
                        <p class="mb-0 small"><b>PhoneExt: </b>{{ provider.IndependentProvider.PhoneExt }}</p>
                        <p class="mb-0 small"><b>AlternatePhone: </b>{{ provider.IndependentProvider.AlternatePhone }}</p>
                        <p class="mb-0 small"><b>Fax: </b>{{ provider.IndependentProvider.Fax }}</p>
                        <p class="mb-0 small"><b>Email: </b>{{ provider.IndependentProvider.Email }}</p>
                        <p class="mb-0 small"><b>NpiNumber: </b>{{ provider.IndependentProvider.NpiNumber }}</p>
                        <p class="mb-0 small"><b>TaxIdentificationNumber: </b>{{ provider.IndependentProvider.TaxIdentificationNumber }}</p>
                        <p class="mb-0 small"><b>SocialSecurityNumber: </b>{{ provider.IndependentProvider.SocialSecurityNumber }}</p>
                        <p class="mb-0 small"><b>Insured: </b>{{ provider.IndependentProvider.Insured }}</p>
                        <p class="mb-0 small"><b>Bonded: </b>{{ provider.IndependentProvider.Bonded }}</p>

                    </b-col>
                    <b-col sm="4">

                        <p class="mb-0 small"><b>CompositeScore: </b>{{ provider.CompositeScore }}</p>
                        <p class="mb-0 small"><b>AddressScore: </b>{{ provider.AddressScore }}</p>
                        <p class="mb-0 small"><b>FirstNameScore: </b>{{ provider.FirstNameScore }}</p>
                        <p class="mb-0 small"><b>LastNameScore: </b>{{ provider.LastNameScore }}</p>
                        <p class="mb-0 small"><b>ProviderNameScore: </b>{{ provider.ProviderNameScore }}</p>
                        <p class="mb-0 small"><b>PhoneScore: </b>{{ provider.PhoneScore }}</p>
                        <p class="mb-0 small"><b>ZipScore: </b>{{ provider.ZipScore }}</p>
                    </b-col>
                </b-row>
            </b-container>

            <div slot="modal-footer">

                <b-button variant="default" @click=" modal = false ">Close</b-button>
            </div>
        </b-modal>
    </b-card>
</template>

<script>

    export default {

        props: {

            providerData     : Object,
            provider         : Object,
            selectProvider   : Function,
            selectedProvider : {

                type         : Object,
                default      : null,
                required     : false
            },
        },
        data(){

            return {

                modal : false,
            }
        },
        methods: {

            selectThis( provider ){

                if( !this.isSelected ) this.selectProvider( provider );
                else this.selectProvider( null );
            }
        },
        computed: {

            isSelected(){

                return this.selectedProvider && this.selectedProvider.UpdId == this.provider.UpdId;
            },
            properVariant(){

                if( this.currentlyThisOne ) return 'light-info';

                if( this.isSelected ) return 'light';

                return 'default';
            },
            currentlyThisOne(){

                if( !this.providerData || !this.providerData.updid ) return false;
                return String( this.providerData.updid ) == String( this.provider.UpdId );
            }
        }
    }
</script>

<style>

</style>